export function getObjectClone<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}